import {
  GET_CALENDAR_EVENTS,
  GET_CALENDAR_EVENTS_SUCCESS,
  GET_CALENDAR_EVENTS_FAIL,
} from "./actionTypes";
const INIT_STATE = {
  calendarEvents: [],
  loadingCalendarEvents: false,
};

const events = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CALENDAR_EVENTS:
      return {
        ...state,
        loadingCalendarEvents: true,
      };
    case GET_CALENDAR_EVENTS_SUCCESS:
      return {
        ...state,
        calendarEvents: action.payload,
        loadingCalendarEvents: false,
      };

    case GET_CALENDAR_EVENTS_FAIL:
      return {
        ...state,
        error: action.payload,
        loadingCalendarEvents: false,
      };
    default:
      return state;
  }
};

export default events;
